<div class="container-fluid" style="margin-top: 15px">
  <div *ngIf="loading"><i class="fas fa-spinner fa-pulse"></i> Loading...</div>

  <mat-tab-group>
    <mat-tab label="Groups">
      <div style="margin: 10px 0">
        <button mat-raised-button class="piButton" [disabled]="!catalogLoaded" (click)="newGroup()">New Group</button>
        <span class="text-muted" *ngIf="!catalogLoaded" style="margin-left: 10px"><i class="fas fa-spinner fa-pulse"></i> Loading tables...</span>
      </div>

      <table class="table table-sm">
        <tr><th></th><th>Name</th><th>Tables</th><th></th></tr>
        <tr *ngFor="let g of groups" [style.opacity]="g.active ? 1 : 0.5">
          <td>
            <a href="#" [class.disabled]="!catalogLoaded" (click)="editGroup(g); false"><span class="fas fa-edit" title="Edit"></span></a>&nbsp;
            <a href="#" (click)="deleteGroup(g); false"><span class="fas fa-trash" title="Delete"></span></a>
          </td>
          <td>{{ g.name }}<span *ngIf="!g.active" class="text-muted"> (inactive)</span></td>
          <td><span *ngFor="let id of g.tableIds; let last = last">{{ tableName(id) }}<span *ngIf="!last">, </span></span></td>
          <td class="text-muted"><span *ngIf="g.allowedColumnIds && g.allowedColumnIds.length > 0">{{ g.allowedColumnIds.length }} column restriction(s)</span></td>
        </tr>
      </table>
      <p class="text-muted" *ngIf="groups.length === 0 && !loading">No Groups yet.</p>
    </mat-tab>

    <mat-tab label="Plan Types">
      <p class="text-muted" style="margin-top: 10px">
        Choose which Groups each plan type's subscribers can build Agent Data Models from. A plan type with no Groups
        cannot create any.
      </p>
      <mat-form-field class="full-width">
        <mat-label>Plan type</mat-label>
        <mat-select [(value)]="selectedPlanTypeId" (selectionChange)="onPlanTypeChange()">
          <mat-option *ngFor="let p of planTypes" [value]="p.interactSubTypeId">{{ p.interactSubTypeName }}</mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container *ngIf="selectedPlanTypeId !== null">
        <mat-form-field class="full-width">
          <mat-label>Groups offered</mat-label>
          <mat-select [(value)]="planTypeGroupIds" multiple>
            <mat-option *ngFor="let g of groups" [value]="g.admGroupId">{{ g.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="row">
          <div class="col-md-12">
            <mat-checkbox [(ngModel)]="planTypeAllowSelfServiceCreate" name="allowSelfServiceCreate">
              Subscribers may build their own Agent Data Models
            </mat-checkbox>
            <p class="text-muted" style="margin: 4px 0 0">
              Off means this plan type only ever gets Agent Data Models curated for it below - no "Create New" button.
            </p>
          </div>
        </div>
        <mat-form-field class="full-width">
          <mat-label>Subscription ADMs offered (curated, consume-only)</mat-label>
          <mat-select [(value)]="planTypeAdmLayoutIds" multiple>
            <mat-option *ngFor="let l of subscriptionAdms" [value]="l.admLayoutId">{{ l.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <p class="text-muted" *ngIf="subscriptionAdms.length === 0">
          No Subscription ADMs exist yet - create one from "My ADMs" with the "Create Subscription ADM" option (admin only).
        </p>
        <button mat-raised-button class="piButton" (click)="savePlanTypeGroups()">Save</button>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
</div>
